export type SpotlightAccountBranding = {
  name: string;
  shortName?: string | null;
};

export const getSpotlightAccountDisplayName = (
  account: SpotlightAccountBranding | null | undefined,
): string => {
  if (!account?.name) {
    return '';
  }

  const shortName = account.shortName?.trim();

  if (shortName) {
    return shortName;
  }

  return account.name;
};
